import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  URL: { input: any; output: any; }
};

export type Artist = {
  __typename?: 'Artist';
  about?: Maybe<Scalars['String']['output']>;
  backgroundColour?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  featured?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  hasProducts: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image: ImageSizes;
  lastName: Scalars['String']['output'];
  lastUploaded?: Maybe<Scalars['Date']['output']>;
  mediums: Array<Medium>;
  normalizedName: Scalars['String']['output'];
  paypalEmail?: Maybe<Scalars['String']['output']>;
  permalink: Scalars['String']['output'];
  products: Array<ArtistProduct>;
  referralCode?: Maybe<Scalars['String']['output']>;
  salesCount: Scalars['Int']['output'];
  uid: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vatRegistered?: Maybe<VatRegistered>;
};


export type ArtistProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtistConnection = {
  __typename?: 'ArtistConnection';
  nodes: Array<Artist>;
  pageInfo: PageInfo;
};

export type ArtistProduct = {
  __typename?: 'ArtistProduct';
  artistCountry?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<Image>;
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  medium: Medium;
  orientation: Orientation;
  title: Scalars['String']['output'];
};

export type Image = {
  __typename?: 'Image';
  altText?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  url: Scalars['URL']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ImageSizes = {
  __typename?: 'ImageSizes';
  large: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  small: Scalars['String']['output'];
};

export enum Medium {
  GraphicDesign = 'graphic_design',
  MixedMedia = 'mixed_media',
  Painting = 'painting',
  Photography = 'photography'
}

export enum Orientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  artist?: Maybe<Artist>;
  artists: ArtistConnection;
  pageViews: Scalars['Int']['output'];
};


export type QueryArtistArgs = {
  id: Scalars['String']['input'];
};


export type QueryArtistsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  medium?: InputMaybe<Medium>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPageViewsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type VatRegistered = {
  __typename?: 'VATRegistered';
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type AdminArtistFragment = { __typename?: 'Artist', id: string, permalink: string, firstName: string, lastName: string, normalizedName: string, email: string, paypalEmail?: string | null, city?: string | null, country?: string | null, lastUploaded?: any | null, vatRegistered?: { __typename?: 'VATRegistered', vatNumber?: string | null } | null };

export type GetAdminArtistsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Medium>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAdminArtistsQuery = { __typename?: 'Query', artists: { __typename?: 'ArtistConnection', nodes: Array<{ __typename?: 'Artist', id: string, permalink: string, firstName: string, lastName: string, normalizedName: string, email: string, paypalEmail?: string | null, city?: string | null, country?: string | null, lastUploaded?: any | null, vatRegistered?: { __typename?: 'VATRegistered', vatNumber?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetArtistQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetArtistQuery = { __typename?: 'Query', artist?: { __typename?: 'Artist', id: string, firstName: string, lastName: string, permalink: string, backgroundColour?: string | null, about?: string | null, image: { __typename?: 'ImageSizes', small: string, medium: string, large: string } } | null };

export type ArtistFragment = { __typename?: 'Artist', id: string, firstName: string, lastName: string, permalink: string, image: { __typename?: 'ImageSizes', small: string, medium: string, large: string } };

export type ArtistWithProductsFragment = { __typename?: 'Artist', id: string, firstName: string, lastName: string, permalink: string, products: Array<{ __typename?: 'ArtistProduct', id: string, handle: string, title: string, artistCountry?: string | null, featuredImage?: { __typename?: 'Image', url: any, altText?: string | null, width?: number | null, height?: number | null } | null }>, image: { __typename?: 'ImageSizes', small: string, medium: string, large: string } };

export type GetArtistsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  medium?: InputMaybe<Medium>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArtistsQuery = { __typename?: 'Query', artists: { __typename?: 'ArtistConnection', nodes: Array<{ __typename?: 'Artist', id: string, firstName: string, lastName: string, permalink: string, image: { __typename?: 'ImageSizes', small: string, medium: string, large: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetArtistsWithProductsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  productLimit: Scalars['Int']['input'];
  medium?: InputMaybe<Medium>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArtistsWithProductsQuery = { __typename?: 'Query', artists: { __typename?: 'ArtistConnection', nodes: Array<{ __typename?: 'Artist', id: string, firstName: string, lastName: string, permalink: string, products: Array<{ __typename?: 'ArtistProduct', id: string, handle: string, title: string, artistCountry?: string | null, featuredImage?: { __typename?: 'Image', url: any, altText?: string | null, width?: number | null, height?: number | null } | null }>, image: { __typename?: 'ImageSizes', small: string, medium: string, large: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetPageViewsQueryVariables = Exact<{
  page: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPageViewsQuery = { __typename?: 'Query', pageViews: number };

export type SearchArtistsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchArtistsQuery = { __typename?: 'Query', artists: { __typename?: 'ArtistConnection', nodes: Array<{ __typename?: 'Artist', id: string, firstName: string, lastName: string, permalink: string, image: { __typename?: 'ImageSizes', small: string, medium: string, large: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export const AdminArtistFragmentDoc = gql`
    fragment AdminArtist on Artist {
  id
  permalink
  firstName
  lastName
  normalizedName
  email
  paypalEmail
  city
  country
  vatRegistered {
    vatNumber
  }
  lastUploaded
}
    `;
export const ArtistFragmentDoc = gql`
    fragment Artist on Artist {
  id
  firstName
  lastName
  permalink
  image {
    small
    medium
    large
  }
}
    `;
export const ArtistWithProductsFragmentDoc = gql`
    fragment ArtistWithProducts on Artist {
  ...Artist
  products(limit: $productLimit) {
    id
    handle
    title
    artistCountry
    featuredImage {
      url
      altText
      width
      height
    }
  }
}
    ${ArtistFragmentDoc}`;
export const GetAdminArtistsDocument = gql`
    query GetAdminArtists($limit: Int!, $country: String, $query: String, $medium: Medium, $afterCursor: String) {
  artists(
    limit: $limit
    country: $country
    query: $query
    medium: $medium
    afterCursor: $afterCursor
  ) {
    nodes {
      ...AdminArtist
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${AdminArtistFragmentDoc}`;

/**
 * __useGetAdminArtistsQuery__
 *
 * To run a query within a React component, call `useGetAdminArtistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminArtistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminArtistsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      country: // value for 'country'
 *      query: // value for 'query'
 *      medium: // value for 'medium'
 *      afterCursor: // value for 'afterCursor'
 *   },
 * });
 */
export function useGetAdminArtistsQuery(baseOptions: Apollo.QueryHookOptions<GetAdminArtistsQuery, GetAdminArtistsQueryVariables> & ({ variables: GetAdminArtistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminArtistsQuery, GetAdminArtistsQueryVariables>(GetAdminArtistsDocument, options);
      }
export function useGetAdminArtistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminArtistsQuery, GetAdminArtistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminArtistsQuery, GetAdminArtistsQueryVariables>(GetAdminArtistsDocument, options);
        }
export function useGetAdminArtistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminArtistsQuery, GetAdminArtistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminArtistsQuery, GetAdminArtistsQueryVariables>(GetAdminArtistsDocument, options);
        }
export type GetAdminArtistsQueryHookResult = ReturnType<typeof useGetAdminArtistsQuery>;
export type GetAdminArtistsLazyQueryHookResult = ReturnType<typeof useGetAdminArtistsLazyQuery>;
export type GetAdminArtistsSuspenseQueryHookResult = ReturnType<typeof useGetAdminArtistsSuspenseQuery>;
export type GetAdminArtistsQueryResult = Apollo.QueryResult<GetAdminArtistsQuery, GetAdminArtistsQueryVariables>;
export const GetArtistDocument = gql`
    query GetArtist($id: String!) {
  artist(id: $id) {
    id
    firstName
    lastName
    permalink
    image {
      small
      medium
      large
    }
    backgroundColour
    about
  }
}
    `;

/**
 * __useGetArtistQuery__
 *
 * To run a query within a React component, call `useGetArtistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetArtistQuery(baseOptions: Apollo.QueryHookOptions<GetArtistQuery, GetArtistQueryVariables> & ({ variables: GetArtistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtistQuery, GetArtistQueryVariables>(GetArtistDocument, options);
      }
export function useGetArtistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtistQuery, GetArtistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtistQuery, GetArtistQueryVariables>(GetArtistDocument, options);
        }
export function useGetArtistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArtistQuery, GetArtistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArtistQuery, GetArtistQueryVariables>(GetArtistDocument, options);
        }
export type GetArtistQueryHookResult = ReturnType<typeof useGetArtistQuery>;
export type GetArtistLazyQueryHookResult = ReturnType<typeof useGetArtistLazyQuery>;
export type GetArtistSuspenseQueryHookResult = ReturnType<typeof useGetArtistSuspenseQuery>;
export type GetArtistQueryResult = Apollo.QueryResult<GetArtistQuery, GetArtistQueryVariables>;
export const GetArtistsDocument = gql`
    query GetArtists($limit: Int!, $medium: Medium, $afterCursor: String, $query: String) {
  artists(
    limit: $limit
    medium: $medium
    afterCursor: $afterCursor
    query: $query
  ) {
    nodes {
      ...Artist
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${ArtistFragmentDoc}`;

/**
 * __useGetArtistsQuery__
 *
 * To run a query within a React component, call `useGetArtistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtistsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      medium: // value for 'medium'
 *      afterCursor: // value for 'afterCursor'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetArtistsQuery(baseOptions: Apollo.QueryHookOptions<GetArtistsQuery, GetArtistsQueryVariables> & ({ variables: GetArtistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtistsQuery, GetArtistsQueryVariables>(GetArtistsDocument, options);
      }
export function useGetArtistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtistsQuery, GetArtistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtistsQuery, GetArtistsQueryVariables>(GetArtistsDocument, options);
        }
export function useGetArtistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArtistsQuery, GetArtistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArtistsQuery, GetArtistsQueryVariables>(GetArtistsDocument, options);
        }
export type GetArtistsQueryHookResult = ReturnType<typeof useGetArtistsQuery>;
export type GetArtistsLazyQueryHookResult = ReturnType<typeof useGetArtistsLazyQuery>;
export type GetArtistsSuspenseQueryHookResult = ReturnType<typeof useGetArtistsSuspenseQuery>;
export type GetArtistsQueryResult = Apollo.QueryResult<GetArtistsQuery, GetArtistsQueryVariables>;
export const GetArtistsWithProductsDocument = gql`
    query GetArtistsWithProducts($limit: Int!, $productLimit: Int!, $medium: Medium, $afterCursor: String, $query: String, $country: String) {
  artists(
    limit: $limit
    medium: $medium
    afterCursor: $afterCursor
    query: $query
    country: $country
  ) {
    nodes {
      ...ArtistWithProducts
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${ArtistWithProductsFragmentDoc}`;

/**
 * __useGetArtistsWithProductsQuery__
 *
 * To run a query within a React component, call `useGetArtistsWithProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtistsWithProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtistsWithProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      productLimit: // value for 'productLimit'
 *      medium: // value for 'medium'
 *      afterCursor: // value for 'afterCursor'
 *      query: // value for 'query'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetArtistsWithProductsQuery(baseOptions: Apollo.QueryHookOptions<GetArtistsWithProductsQuery, GetArtistsWithProductsQueryVariables> & ({ variables: GetArtistsWithProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtistsWithProductsQuery, GetArtistsWithProductsQueryVariables>(GetArtistsWithProductsDocument, options);
      }
export function useGetArtistsWithProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtistsWithProductsQuery, GetArtistsWithProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtistsWithProductsQuery, GetArtistsWithProductsQueryVariables>(GetArtistsWithProductsDocument, options);
        }
export function useGetArtistsWithProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArtistsWithProductsQuery, GetArtistsWithProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArtistsWithProductsQuery, GetArtistsWithProductsQueryVariables>(GetArtistsWithProductsDocument, options);
        }
export type GetArtistsWithProductsQueryHookResult = ReturnType<typeof useGetArtistsWithProductsQuery>;
export type GetArtistsWithProductsLazyQueryHookResult = ReturnType<typeof useGetArtistsWithProductsLazyQuery>;
export type GetArtistsWithProductsSuspenseQueryHookResult = ReturnType<typeof useGetArtistsWithProductsSuspenseQuery>;
export type GetArtistsWithProductsQueryResult = Apollo.QueryResult<GetArtistsWithProductsQuery, GetArtistsWithProductsQueryVariables>;
export const GetPageViewsDocument = gql`
    query GetPageViews($page: String!, $id: String, $handle: String, $startDate: String, $endDate: String) {
  pageViews(
    page: $page
    id: $id
    handle: $handle
    startDate: $startDate
    endDate: $endDate
  )
}
    `;

/**
 * __useGetPageViewsQuery__
 *
 * To run a query within a React component, call `useGetPageViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageViewsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      id: // value for 'id'
 *      handle: // value for 'handle'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetPageViewsQuery(baseOptions: Apollo.QueryHookOptions<GetPageViewsQuery, GetPageViewsQueryVariables> & ({ variables: GetPageViewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageViewsQuery, GetPageViewsQueryVariables>(GetPageViewsDocument, options);
      }
export function useGetPageViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageViewsQuery, GetPageViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageViewsQuery, GetPageViewsQueryVariables>(GetPageViewsDocument, options);
        }
export function useGetPageViewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageViewsQuery, GetPageViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageViewsQuery, GetPageViewsQueryVariables>(GetPageViewsDocument, options);
        }
export type GetPageViewsQueryHookResult = ReturnType<typeof useGetPageViewsQuery>;
export type GetPageViewsLazyQueryHookResult = ReturnType<typeof useGetPageViewsLazyQuery>;
export type GetPageViewsSuspenseQueryHookResult = ReturnType<typeof useGetPageViewsSuspenseQuery>;
export type GetPageViewsQueryResult = Apollo.QueryResult<GetPageViewsQuery, GetPageViewsQueryVariables>;
export const SearchArtistsDocument = gql`
    query SearchArtists($limit: Int!, $query: String) {
  artists(limit: $limit, query: $query) {
    nodes {
      ...Artist
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${ArtistFragmentDoc}`;

/**
 * __useSearchArtistsQuery__
 *
 * To run a query within a React component, call `useSearchArtistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchArtistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchArtistsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchArtistsQuery(baseOptions: Apollo.QueryHookOptions<SearchArtistsQuery, SearchArtistsQueryVariables> & ({ variables: SearchArtistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchArtistsQuery, SearchArtistsQueryVariables>(SearchArtistsDocument, options);
      }
export function useSearchArtistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchArtistsQuery, SearchArtistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchArtistsQuery, SearchArtistsQueryVariables>(SearchArtistsDocument, options);
        }
export function useSearchArtistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchArtistsQuery, SearchArtistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchArtistsQuery, SearchArtistsQueryVariables>(SearchArtistsDocument, options);
        }
export type SearchArtistsQueryHookResult = ReturnType<typeof useSearchArtistsQuery>;
export type SearchArtistsLazyQueryHookResult = ReturnType<typeof useSearchArtistsLazyQuery>;
export type SearchArtistsSuspenseQueryHookResult = ReturnType<typeof useSearchArtistsSuspenseQuery>;
export type SearchArtistsQueryResult = Apollo.QueryResult<SearchArtistsQuery, SearchArtistsQueryVariables>;
export type ArtistKeySpecifier = ('about' | 'backgroundColour' | 'city' | 'country' | 'createdAt' | 'email' | 'featured' | 'firstName' | 'hasProducts' | 'id' | 'image' | 'lastName' | 'lastUploaded' | 'mediums' | 'normalizedName' | 'paypalEmail' | 'permalink' | 'products' | 'referralCode' | 'salesCount' | 'uid' | 'updatedAt' | 'vatRegistered' | ArtistKeySpecifier)[];
export type ArtistFieldPolicy = {
	about?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColour?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	hasProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUploaded?: FieldPolicy<any> | FieldReadFunction<any>,
	mediums?: FieldPolicy<any> | FieldReadFunction<any>,
	normalizedName?: FieldPolicy<any> | FieldReadFunction<any>,
	paypalEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	permalink?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	referralCode?: FieldPolicy<any> | FieldReadFunction<any>,
	salesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	uid?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRegistered?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ArtistConnectionKeySpecifier = ('nodes' | 'pageInfo' | ArtistConnectionKeySpecifier)[];
export type ArtistConnectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ArtistProductKeySpecifier = ('artistCountry' | 'featuredImage' | 'handle' | 'id' | 'medium' | 'orientation' | 'title' | ArtistProductKeySpecifier)[];
export type ArtistProductFieldPolicy = {
	artistCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredImage?: FieldPolicy<any> | FieldReadFunction<any>,
	handle?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	medium?: FieldPolicy<any> | FieldReadFunction<any>,
	orientation?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageKeySpecifier = ('altText' | 'height' | 'url' | 'width' | ImageKeySpecifier)[];
export type ImageFieldPolicy = {
	altText?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageSizesKeySpecifier = ('large' | 'medium' | 'small' | ImageSizesKeySpecifier)[];
export type ImageSizesFieldPolicy = {
	large?: FieldPolicy<any> | FieldReadFunction<any>,
	medium?: FieldPolicy<any> | FieldReadFunction<any>,
	small?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('artist' | 'artists' | 'pageViews' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	artist?: FieldPolicy<any> | FieldReadFunction<any>,
	artists?: FieldPolicy<any> | FieldReadFunction<any>,
	pageViews?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VATRegisteredKeySpecifier = ('vatNumber' | VATRegisteredKeySpecifier)[];
export type VATRegisteredFieldPolicy = {
	vatNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	Artist?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ArtistKeySpecifier | (() => undefined | ArtistKeySpecifier),
		fields?: ArtistFieldPolicy,
	},
	ArtistConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ArtistConnectionKeySpecifier | (() => undefined | ArtistConnectionKeySpecifier),
		fields?: ArtistConnectionFieldPolicy,
	},
	ArtistProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ArtistProductKeySpecifier | (() => undefined | ArtistProductKeySpecifier),
		fields?: ArtistProductFieldPolicy,
	},
	Image?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageKeySpecifier | (() => undefined | ImageKeySpecifier),
		fields?: ImageFieldPolicy,
	},
	ImageSizes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageSizesKeySpecifier | (() => undefined | ImageSizesKeySpecifier),
		fields?: ImageSizesFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	VATRegistered?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VATRegisteredKeySpecifier | (() => undefined | VATRegisteredKeySpecifier),
		fields?: VATRegisteredFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    